import React from "react";

export type WizardStepProps = {
  id: string;
  label: React.ReactNode;
  isCheckable?: boolean;
  controls?: boolean;
  continueLabel?: React.ReactNode;
  skipLabel?: React.ReactNode;
  controlsCallback?: (index: number) => any;
  children: React.ReactNode;
};

export const WizardStep: React.FC<WizardStepProps> = ({ children }) => {
  return <>{children}</>;
};
